<template>
    <div>
        <HeaderNav v-if="!isWeixinBrowser()" :beforecolor="'#fff'" :backcolor="getCourseBuyButtonColor(courseId)" @returnBack="goToBack"></HeaderNav>
        <div class="imgLazyLoadHead">
            <div  v-if="noShowGuideWordsAfter == 0"  class="bubbleContainer" @click="guideWordsAfterClick">
                <div class="text">本书全部词汇</div>
                <div class="img"><img src="../../../assets/play_arrow.png"/></div>
            </div>
            <img v-bind:src="getheadImage()"/>
        </div>
        <div class="page-navbar">
            <mt-navbar class="page-part" v-model="selected">
                <mt-tab-item id="1" :style="parseInt(selected) === 1 ? isSelected(courseId) : {cursor: 'pointer'}">课程列表</mt-tab-item>
                <mt-tab-item id="2" :style="parseInt(selected) === 2 ? isSelected(courseId) : {cursor: 'pointer'}">词汇表</mt-tab-item>
            </mt-navbar>
            <mt-tab-container v-model="selected">
                <mt-tab-container-item id="1">
                    <div class="course_list_content" v-bind:style="{backgroundColor:getCourseSubColor(courseId2)}">
                        <ul class="lesson_list">
                            <li v-for="(item, index) in obj240WordsHomeInfo.lessonArray" :key="index"
                                @click="lessonClick(item.pk)">
                                <div class="lesson_item_left" v-bind:style="{color:getCourseWordColor(courseId2)}">
                                    <div class="no">{{item.lessonNo}}</div>
                                    <div class="unit">Lesson</div>
                                </div>
                                <div class="lesson_item_center">
                                    <div class="name" v-bind:style="{color:getCourseWordColor(courseId2)}">
                                        {{item.name}}
                                    </div>
                                    <div class="vocabulary">{{item.vocabularyStrategy}}</div>
                                    <div class="keywords">{{item.keyWords}}</div>
                                </div>
                                <div class="lesson_item_right">
                                    <img class="img1" src="@/assets/growth_right.png" height="12.5" width="8"/>
                                    <span v-if="getCount(item.finishPartCount) < getCount(item.partCount)">
                                        {{getCount(item.finishPartCount)}}/{{getCount(item.partCount)}}</span>
                                    <img class="img2" v-else src="@/assets/240_course_finished.png" height="48"
                                         width="60"/>
                                </div>
                                <div class="clear"></div>
                            </li>
                        </ul>
                        <div class="lesson_list_bottom"></div>
                    </div>
                </mt-tab-container-item>
                <mt-tab-container-item id="2">
                    <div :style="{backgroundColor:getCourseSubColor(courseId2)}">
                        <div class="Words_glossary_item" v-for="(item,index) in WordsGlossaryArray" :key="index">
                            <div :id="'section_' + item.initial" :style="{'padding-top':(44 + getStatusHeight())+'px', 'margin-top': '-'+(44 + getStatusHeight())+'px'}">
                                <div class="section_title">{{item.initial}}</div>
                            </div>
                            <div class="Words_glossary_wordsitem" v-for="(section,index) in item.sections" :key="index"
                                 @click="wordClick(section.youdaoUrl, section.pk, section.word)">
                                <div class="Word" :style="{color:isEmpty(section.youdaoUrl) ? '#ff5050' : '#333333'}">
                                    {{section.word}}
                                    <span v-if="getCount(section.subscript) > 0">{{getCount(section.subscript)}}</span>
                                </div>
                                <div class="point">···············</div>
                                <div class="lesson_name">Lesson {{section.lessonNo}}</div>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </div>
                    <div class="Words_glossary_indexs">
                        <div class="Words_glossary_indexsitem" v-for="(item,index) in WordsGlossaryArray" :key="index"
                             @click="scrollToPositin(item.initial)">
                            {{item.initial}}
                        </div>
                    </div>
                </mt-tab-container-item>
            </mt-tab-container>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selected: '1',
                courseId: parseInt(this.$route.query.courseId),
                courseId2: 0,
                obj240WordsHomeInfo: {},
                imgUrl: "",
                totalPartCount: 4,
                WordsGlossaryArray: [],
                noShowGuideWordsAfter:1
            }
        },
        watch : {
            selected(newV){
                window.console.log(newV);

                if (parseInt(newV) === 2) {
                    this.guideWordsAfterClick();
                }
            }
        },
        methods: {
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        var vUrl = "readingclubapp:gobackMyCourse";
                        document.location = vUrl;
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    this.goBack(this.$router);
                }
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            },
            getheadImage:function(){
                return require('@/assets/w' + this.courseId + '.jpg');
            },
            guideWordsAfterClick:function(){
                let that = this;

                if (that.noShowGuideWordsAfter === 1) {
                    return;
                }

                that.$axios.get("240words/saveGuidePrompt/key1").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideWordsAfter = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            lessonClick: function (pk) {
                this.$router.push({
                    name: 'wordLesson',
                    query: {courseId: this.courseId, lessonId: pk}
                });
            },
            wordClick: function (youdaoUrl, wordId, word) {
                if (!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                } else {
                    this.$router.push({
                        name: 'wordCard', query: {courseId: this.courseId, wordId: wordId, word: word}
                    });
                }
            },
            isSelected(id) {
                return {
                    color: this.getCourseMainColor(id),
                    'border-bottom': '3px solid ' + this.getCourseMainColor(id),
                    cursor: 'pointer'
                };
            },
            getFirstLettersArray(array) {
                let firstLetters = [];

                array.forEach(item => {
                    if (firstLetters.indexOf(item.firstLetter) === -1) {
                        firstLetters.push(item.firstLetter);
                    }
                });

                return firstLetters;
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            }
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let url2 = "240words/getGlossary/" + vCourseId;
            let url = "240words/homeInfo/" + vCourseId + "/1";

            that.$axios.get(url).then((response) => {
                window.console.log(JSON.stringify(response.data))
                that.obj240WordsHomeInfo = response.data;
                that.imgUrl = this.$qiNiuDomainBase + that.obj240WordsHomeInfo.h5Picture;
                that.noShowGuideWordsAfter = that.getCount(that.obj240WordsHomeInfo.key1);
                that.courseId = vCourseId;
                that.courseId2 = vCourseId;
            }).catch(function (error) {
                window.console.log(error)
            });

            that.$axios.get(url2).then((response) => {
                let wordsGlossarys = response.data;
                let firstLetters = that.getFirstLettersArray(wordsGlossarys);

                firstLetters.forEach(initial => {
                    let sections = wordsGlossarys.filter(wordsGlossary => wordsGlossary.firstLetter === initial);
                    that.WordsGlossaryArray.push({
                        initial,
                        sections
                    });
                })
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {
            window.AfterScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.AfterScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.AfterScrollTop);
        }
    }
</script>
<style scoped>
    .imgLazyLoadHead {
        position: relative;
        padding: 0px;
    }
    .imgLazyLoadHead img {
        display: block;
        width: 100%;
        margin: auto;
    }
    .course_list_content {
       height: auto;
    }
    .lesson_list:first-child {
        padding-top: 15px;
    }
    .lesson_list:last-child {
        padding-top: 15px;
    }
    .lesson_list li {
        background-color: white;
        margin: 0px 10px 15px 10px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        padding: 15px;
        position: relative;
    }
    .lesson_list li .lesson_item_left {
        float: left;
        width: 70px;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }
    .lesson_list li .lesson_item_left .no {
        font-size: 40px;
        font-weight: bold;
        line-height: 32px;
        text-align: center;
    }
    .lesson_list li .lesson_item_left .unit {
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
    }
    .lesson_list li .lesson_item_center {
        margin-left: 80px;
        float: left;
        width: calc(100% - 130px);
    }
    .lesson_list li .lesson_item_center .name {
        text-align: left;
        font-size: 25px;
        font-weight: bold;
    }
    .lesson_list li .lesson_item_center .vocabulary {
        text-align: left;
        font-size: 13px;
        color: #666666;
    }
    .lesson_list li .lesson_item_center .keywords {
        text-align: left;
        font-size: 13px;
        color: #666666;
    }
    .lesson_list li .lesson_item_center div {

    }
    .lesson_list li .lesson_item_right {
        width: 50px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }
    .lesson_list li .lesson_item_right .img1 {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }
    .lesson_list li .lesson_item_right .img2 {
        position: absolute;
        top: 5px;
        right: 15px;
        -webkit-transform: translateY(5px);
    }
    .lesson_list li .lesson_item_right span {
        position: absolute;
        right: 15px;
        bottom: 15px;
        font-size: 15px;
        color: #999999;
    }
    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .lesson_list_bottom {
        height: 50px;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    .Words_glossary_item .section_title {
        background-color: #f4f4f4;
        text-align: left;
        height: 25px;
        font-size: 14px;
        color: #666666;
        line-height: 25px;
        padding-left: 15px;
    }
    .Words_glossary_wordsitem {
        position: relative;
        height: 60px;
    }
    .Words_glossary_wordsitem .Word {
        position: absolute;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        padding: 5px 16px 5px 16px;
        left: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        background-color: white;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }
    .Words_glossary_wordsitem .Word span {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        color: #999999;
        font-weight: normal;
    }
    .Words_glossary_wordsitem .point {
        text-align: center;
        font-size: 14px;
        color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .Words_glossary_wordsitem .lesson_name {
        position: absolute;
        text-align: left;
        right: 30px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        color: white;
        font-size: 15px;
    }
    .Words_glossary_indexs {
        position: fixed;
        bottom: 30px;
        right: 0;
        z-index: 999;
    }
    .Words_glossary_indexs .Words_glossary_indexsitem {
        font-size: 10px;
        font-weight: bold;
        color: #333333;
        height: 15px;
        width: 25px;
    }
    .bubbleContainer{
        position: absolute;
        bottom: 0px;
        left: calc(50% + (50% - 120px)/2);
        padding-bottom: 6px;
    }
    .bubbleContainer .text {
        color: white;
        background-color: #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer .img {
        position: absolute;
        bottom: 0px;
        width: 12px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .bubbleContainer .img img {
        width: 12px;
    }
</style>
